/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(document).ready(function() {
  jQuery(".accord_panel > h4").on("click", function() {
    if (jQuery(this).hasClass("active")) {
      jQuery(this).removeClass("active");
      jQuery(this)
        .siblings(".accord_panel_content")
        .slideUp(200);
      jQuery(".accord_panel > h4 i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      jQuery(".accord_panel > h4 i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      jQuery(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      jQuery(".accord_panel > h4").removeClass("active");
      jQuery(this).addClass("active");
      jQuery(".accord_panel_content").slideUp(200);
      jQuery(this)
        .siblings(".accord_panel_content")
        .slideDown(200);
    }
  });

  setTimeout(function() {
    $('#custom-product-first').prop("selectedIndex", 0);
    $('#custom-product-second').prop("selectedIndex", 0);
  },2000);
  
});

$(document).ready(function(){

  //Product page - image slider
  $('.Product__Slideshow .Product__SlideItem .AspectRatio').removeClass('hide');
  var $carousel = $('.Product__Slideshow').flickity();

  var $carouselNav = $('.carousel-nav');
  var $carouselNavCells = $carouselNav.find('.carousel-cell');

  $(document).on('click', '.carousel-nav .carousel-cell', function(e){
    var index = $( e.currentTarget ).index();
    $carousel.flickity( 'select', index );
  });

  var flkty = $carousel.data('flickity');
  //var navTop  = $carouselNav.position().top;
  var navCellHeight = $carouselNavCells.height();
  var navHeight = $carouselNav.height();

  $carousel.on( 'select.flickity', function() {
    // set selected nav cell
    $carouselNav.find('.is-nav-selected').removeClass('is-nav-selected');
    var $selected = $carouselNavCells.eq( flkty.selectedIndex )
      .addClass('is-nav-selected');
    // scroll nav
    var scrollY = $selected.position().top +
      $carouselNav.scrollTop() - ( navHeight + navCellHeight ) / 2;
    $carouselNav.animate({
      scrollTop: scrollY
    });
  });

  // Video section
  $(document).on('click', '.video-section .video-block', function(){
    $(this).toggleClass('play');
    if($(this).hasClass('play')){
      $(this).find('video').get(0).play();
      $(this).find('svg').hide();
    } else {
      $(this).find('video').get(0).pause();
      $(this).find('svg').show();
    }
  });
  
});